import React, { useMemo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import { ChildrenPropType } from '../../../prop-types/children';

import style from './order-details-selected-content-header.module.less';

export const OrderDetailsSelectedContentHeader = ({ children, className }) => {
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <div className={classnames(style['order-details-selected-content-header'], className)} style={zIndexStyle}>
      {children}
    </div>
  );
};

OrderDetailsSelectedContentHeader.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
};
